import { Navigate, useParams } from 'react-router-dom';

export const UserRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/users/${id}/edit`} replace />;
};